export * from './has-any-permission.directive';
